<template>
  <div v-if="loading" class="text-center mt-5">
    <img src="https://cdn.gavleenergi.se/img/spinner.gif" height="135" /><br /><strong>Hämtar transaktioner</strong>
  </div>
  <div v-if="!loading && this.transactions.length == 0">Inga transaktioner hittades</div>
  <div v-if="!loading && this.transactions.length > 0" class="container">
    <div class="row gx-2">
      <div class="col">
        <div class="card p-4">
          <span class="text-50 mb-2">Hittils denna månad</span>
          <strong>{{ thisMonthTotal.kwh.toFixed(0) }} kWh</strong><span class="">{{ thisMonthTotal.sek.toFixed(0) }} kr</span>
        </div>
      </div>
      <div class="col">
        <div class="card p-4">
          <span class="text-50 mb-2">Föregående månad</span>
          <strong> {{ lastMonthTotal.kwh.toFixed(0) }} kWh</strong><span class=""> {{ lastMonthTotal.sek.toFixed(0) }} kr</span>
        </div>
      </div>
    </div>

    <VueApexCharts type="line" :options="chartOptions" :series="chartSeries" class="w-100"></VueApexCharts>

    <strong class="mt-4 mb-3 text-center">Transaktioner</strong>

    <div class="mt-2" v-for="(item, i) in paginationFilter()" :key="i">
      <div class="card" data-bs-toggle="modal" :data-bs-target="'#view-' + item.ExtraChargeId">
        <div class="card-body py-4">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <div class="me-2">
                <div class="icon bg-secondary p-2 d-inline-block rounded-circle">
                  <i class="far fa-charging-station fa-fw" aria-hidden="true"></i>
                </div>
              </div>

              <div class="">
                <strong>{{ item.ChargePlace }}</strong
                ><br />
                <small>{{ item.ChargeDay }}</small>
              </div>
            </div>

            <div class="text-end m-0">
              <strong>{{ ((item.Amount * item.Price) / 100).toFixed(0) }} kr</strong><br />
              <small>{{ item.Minutes }} - {{ item.Amount }} kWh</small>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        :id="'view-' + item.ExtraChargeId"
        tabindex="-1"
        :aria-labelledby="'view-' + item.ExtraChargeId + '-Label'"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ item.ProductName }} {{ item.StartDate }}</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="d-flex justify-content-between mb-2">
                <span>Laddat</span>
                {{ item.Amount }} kWh
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span>Pris per kWh</span>
                {{ item.Price }} öre
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span>Att betala</span>
                {{ (item.Amount * item.Price) / 100 }} kr
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span>Tid</span>
                {{ item.InvoiceFreeText.slice(15, 29) }}
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span>Varaktighet</span>
                {{ item.Minutes }}
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span>Laddstolpe</span>
                <span class="text-end"> {{ item.ChargePlace }} ({{ item.UtilityId }}) </span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <div v-if="item.FullyInvoiced !== 1" class="text-end d-flex align-items-center justify-content-end">
                  <div class="me-1" style="height: 14px; width: 14px; border-radius: 50%; background-color: var(--bs-warning)"></div>
                  Ej fakturerad
                </div>
                <div v-if="item.FullyInvoiced == 1" class="text-end d-flex align-items-center justify-content-end">
                  <div class="me-1" style="height: 14px; width: 14px; border-radius: 50%; background-color: var(--bs-success)"></div>
                  Fakturerad
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between p-1 mt-2">
      
    <div>Visar {{ visibleTransactions}}</div>
  <button class="btn btn-lg btn-light" @click="perPage += 10">Visa fler</button>
    </div>
    <nav class="mt-4">
      
      <ul class="pagination justify-content-center text-center g-2">
        <li class="page-item">
          <a class="page-link d-flex align-items-center justify-content-center" :class="{ disabled: currentPage == 1 }" @click="currentPage = 1" tabindex="-1"><i class="fa-solid fa-angles-left"></i></a>
        </li>

        <li  class="page-item">
          <a class="page-link d-flex align-items-center justify-content-center" :class="{ disabled: currentPage == 1 }" @click="currentPage--" tabindex="-1"><i class="fa-solid fa-angle-left"></i></a>
        </li>


        <!-- <template v-for="(n, i) in pages">
          <li v-if="(n >= currentPage - 2 && n <= currentPage + 1 ) || (currentPage > pages -2 && n >=  pages - 4) || (currentPage < 3 && n <= 5)" class="page-item" :key="i" :class="{ active: currentPage == n }">
            <a class="page-link d-flex align-items-center justify-content-center" @click="currentPage = n">{{ n }}</a>
          </li>
        </template> -->



        <li  class="page-item" >
          <a class="page-link d-flex align-items-center justify-content-center" :class="{ disabled: currentPage == pages }" @click="currentPage++"><i class="fa-solid fa-angle-right"></i></a>
        </li>



        <li class="page-item">
          <a class="page-link d-flex align-items-center justify-content-center" :class="{ disabled: currentPage == pages }" @click="currentPage = pages"><i class="fa-solid fa-angles-right"></i></a>
        </li>
      </ul>
    </nav>
    
  </div>
  <componentStyles>
    :root { font-family: 'Encode Sans', sans-serif !important; --color-primary: #47525D; --color-primary-dark: #3C454E; --color-primary-medium:
    #FFB47E; /* --color-primary-light: #FFF2E3; */ --color-primary-light: #EBECED; } .page-link { color: var(--color-primary); 
    border-radius: 50%; border: 1px solid #0000002d; font-size: 12px; height: 42px; width: 42px; } .page-item.active .page-link { background-color: var(--color-primary); border-color: var(--color-primary);
    color: #fff !important; } .page-item:not(:first-child) .page-link{ margin-left:13px; }  .page-link:hover{ color: var(--color-primary); cursor:
    pointer; } .page-item:first-child .page-link, .page-item:last-child .page-link { border-radius: 50%; } .page-link:focus { z-index: 3; color:
    var(--color-primary); background-color: var(--color-primary-light); box-shadow: none; }
  .page-link.disabled {color: lightgray !important;} .btn.btn-light, .btn.btn-light:active { color: var(--color-primary) !important; background-color:#fff !important; border: 1px solid #0000002d; }
  </componentStyles>
</template>

<script>
import componentStyles from "../componentStyles.vue";
import VueApexCharts from "vue3-apexcharts";
//import json from "./data.json";
export default {
  components: { VueApexCharts, componentStyles },
  props: ["cc"],
  data() {
    let transactions = [];

    let perPage = 10;
    let pages = Math.ceil(transactions.length / perPage);

    return {
      transactions,
      currentPage: 1,
      perPage,
      pages,
      loading: true,
      visibleTransactions: "",

      chartOptions: {
        colors: ["#f28c00"],
        fill: {
          type: "gradient",
          gradient: {
            type: "vertical",
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
              {
                offset: 80,
                color: "#f28e00",
                opacity: 1,
              },
              {
                offset: 99,
                color: "#d4134e",
                opacity: 1,
              },
            ],
          },
        },
        grid: {
          show: false,
        },
        tooltip: {
          custom: function ({ series, dataPointIndex, w }) {
            return (
              '<table class="card p-2">' +
              "<tr><td>" +
              w.globals.categoryLabels[dataPointIndex] +
              ':</td><td class="text-end"> ' +
              series[0][dataPointIndex] +
              " kWh</td></tr>" +
              "</table>"
            );
          },
        },
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },

        stroke: {
          curve: "smooth",
        },
        xaxis: {
          labels: {},
          categories: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
        },
        yaxis: {
          decimalsInFloat: 0,
          title: {
            text: "kWh",
          },
        },
      },
    };
  },
  methods: {
    async fetchData() {
      await fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/laddtransaktioner?cc=" + this.cc)
        .then((res) => res.json())
        .then((json) => {
          this.transactions = json.VirtaExtracharges;
          console.log(json.VirtaExtracharges);
        });

      await this.transactions.sort((b, a) => {
        return (
          new Date(a.StartDate.slice(0, 11) + a.InvoiceFreeText.slice(16, 21)) - new Date(b.StartDate.slice(0, 11) + b.InvoiceFreeText.slice(16, 21))
        );
      });

      let days = ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag", "Söndag"];
      let months = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

      this.transactions.forEach((item) => {
        let date = new Date(item.StartDate);
        date.setHours(date.getHours() + 1);

        item.ChargeDay = days[date.getDay()] + " " + date.getDate() + ", " + months[date.getMonth()];
        item.StartDate = date.toLocaleString("sv-SE", { timeZone: "CET" }).slice(0, 10);
        let a = "adress:";
        let start = item.InvoiceFreeText.indexOf("adress:") + a.length;

        //För äldre laddningar där plats inte finns med i svaret från apiet.
        if (start < 8) {
          item.ChargePlace = "";
        } else {
          item.ChargePlace = item.InvoiceFreeText.slice(start, item.InvoiceFreeText.length);
        }
        item.Minutes = item.InvoiceFreeText.slice(item.InvoiceFreeText.indexOf("=") + 2, item.InvoiceFreeText.indexOf("."));
        this.loading = false;
      });
    },

    paginationFilter() {
      this.pages = Math.ceil(this.transactions.length / this.perPage);
      this.visibleTransactions = (this.currentPage * this.perPage - this.perPage + 1 ) + "-" + ((this.currentPage * this.perPage) > this.transactions.length ? this.transactions.length : this.currentPage * this.perPage) + " av " + (this.transactions.length);
      return this.transactions.slice(this.currentPage * this.perPage - this.perPage, this.currentPage * this.perPage);
    },
  },

  computed: {
    lastMonthTotal() {
      let sekTotal = 0;
      let kwhTotal = 0;

      this.transactions.map((item) => {
        let date = new Date(item.StartDate);
        let now = new Date();
        let lastMonth = new Date().getMonth()-1;
        let lastMonthYear = new Date().getFullYear();
             
        //vid årskifte
        if(lastMonth == -1){

          lastMonth = 11
          lastMonthYear = now.getFullYear() -1;

        } 

      if  (date.getMonth() == lastMonth && date.getFullYear() == lastMonthYear){

          kwhTotal += item.Amount;
          sekTotal += (item.Amount * item.Price) / 100;


          
        console.log(date.getMonth() + " " + date.getFullYear())

      }
       
      });

      return {
        sek: sekTotal,
        kwh: kwhTotal,
      };
    },
    thisMonthTotal() {
      let sekTotal = 0;
      let kwhTotal = 0;

      this.transactions.map((item) => {
        let date = new Date(item.StartDate);
        let now = new Date();

        if (now.getMonth() == date.getMonth() && now.getFullYear() == date.getFullYear()) {
          kwhTotal += item.Amount;
          sekTotal += (item.Amount * item.Price) / 100;

          
        console.log(date.getMonth() + " " + date.getFullYear())
        }
      });

      return {
        sek: sekTotal,
        kwh: kwhTotal,
      };
    },

    chartSeries() {
      //Endast nuvarande år visas i diagrammet.
      let arr1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      let today = new Date();
      
      let currentYear = today.getFullYear();

      this.transactions.map((item) => {
        let date = new Date(item.StartDate);

        let month = date.getMonth();
        if (date.getFullYear() == currentYear) {
          arr1[month] += item.Amount;
        }
      });

      return [{ data: arr1 }];
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
